import React from 'react';

const CarIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <path
      d='m9 14 1.5-4.5h11L23 14m-1.5 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-11 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M22.92 9c-.2-.58-.76-1-1.42-1h-11c-.66 0-1.22.42-1.42 1L7 15v8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h12v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8l-2.08-6z'
      fill='currentColor'
      fillRule='nonzero'
    />
  </svg>
);

export default CarIcon;
